function num(a: any, b: any): number {
    return (a !== undefined && a !== null) ? a : (b || 0);
}

export class ChatResponseDto {
    public conversacionId: number = 0;
    public respuesta: string = "";
    public herramientasUsadas: string[] = [];

    constructor(data?: any) {
        if (!data) { return; }
        this.conversacionId   = num(data.ConversacionId, data.conversacionId);
        this.respuesta        = data.Respuesta  || data.respuesta  || "";
        const raw = data.HerramientasUsadas || data.herramientasUsadas;
        this.herramientasUsadas = Array.isArray(raw) ? raw : [];
    }
}
